import { render, staticRenderFns } from "./questionbankInformation.vue?vue&type=template&id=f36447ce"
import script from "./questionbankInformation.vue?vue&type=script&lang=js"
export * from "./questionbankInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports